var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTl(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "28px",
    height: "20px",
    viewBox: "0 0 28 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "flags / TL") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0,
    width: 28,
    height: 20,
    rx: 2
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "flags-/-TL",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Mask",
    fill: "#FFFFFF",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Mask-Copy",
    fill: "#FF323E",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 28,
    height: 20
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83",
    fill: "#FFCC51",
    mask: "url(#mask-2)",
    points: "0 0 17.3333333 10 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Rectangle-83",
    fill: "#262626",
    mask: "url(#mask-2)",
    points: "0 0 12 10 0 20"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Star-8",
    fill: "#FFFFFF",
    mask: "url(#mask-2)",
    transform: "translate(5.227272, 9.583114) rotate(-30.000000) translate(-5.227272, -9.583114) ",
    points: "5.22727222 11.0164063 3.49198354 12.2534489 4.13224731 10.2208241 2.41951616 8.95273373 4.55050961 8.93354515 5.22727222 6.91277954 5.90403483 8.93354515 8.03502828 8.95273373 6.32229713 10.2208241 6.9625609 12.2534489"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTl);
export default __webpack_public_path__ + "static/media/TL.a0d11bbfbeb597822d24baee97b59573.svg";
export { ForwardRef as ReactComponent };